import { BaseIP } from "../CommonAPI/CommonApi";

//=========================Press Output ==============================================================
export const GetPendingOrderData = BaseIP +"production/pressOutput/getPendingOrderList" //(params = ?id=1)
export const SavePressOutputData = BaseIP +"production/pressOutput/savePressOutput"
export const GetPressOutputData = BaseIP +"production/pressOutput/getPressOutputData" //get outside table ata

export const GetPressOutputRackData = BaseIP +"production/pressOutput/getByRackListForPressOutput" // (Get Rack Dropdown Data)

export const GetStockData = BaseIP +"production/pressOutput/getByRackListForPressOutput" // (Get Pending Stock Table Data)
export const GetPendingStockIdData = BaseIP +"Production/NewStock/getNewStockList" // (Get Stock ID Dropdown Data)

export const CreateStockIdData = BaseIP +"Production/NewStock/saveNewStock" // (Create Stock Id Data) (POST)
export const GetStockIdData = BaseIP +"Production/NewStock/generateStockId" // (Show Stock Id Data in Input Field) (GET)

//=========================Close Rack==============================================================
export const GetRackDataByStatus = BaseIP +"production/pressOutput/getByRackStatus" //for rack dropdown
export const GetCloseRackData = BaseIP +"production/pressOutput/getCloseRackList" //for table
export const SaveCloseRackData = BaseIP +"production/pressOutput/closeRack" //(params= ?rackNumberId=1&ageingStatus=1) (update the data of rack (Use PUT Method))
export const GetRackDetails = BaseIP + "production/pressOutput/rackInfo"

//========================= AGEGING =============================================================
export const SaveAgegingData = BaseIP +"production/ageing/saveAgeing"
export const SaveCompletedAgegingData = BaseIP + "production/ageing/completeAgeing"
export const GetAgegingData = BaseIP +"production/ageing/getAgeingList"
export const GetRackNumberData = BaseIP +"production/ageing/getRackList"


//========================= PACKING DETAILS ENTRY ===================================================
export const GetRackData = BaseIP +"packingDetails/getRackNumber" //for rack dropdown
export const GetItemNamesDataByRackId = BaseIP +"packingDetails/getItemsByRackNumber" //(params=> ?rackNumberId=2) (to get dropdown for item names by rack id)
export const GetAllDataByItemId = BaseIP +"packingDetails/getDetailsByItemName" //(params=> ?pressOutputId=2) (to get all data)
export const GetAllocationTypeData = BaseIP +"packingDetails/getAllocatedList" //(params=> ?dieNameId=6&alloyId=2&temperId=5) (to Get allocation Type dropdown data)

export const SaveAllPackingData = BaseIP +"packingDetails/savePackingDetail" // (to SAVE all data)
export const UpdateAllPackingData = BaseIP +"packingDetails/updatePackingDetails" // (to UPDATE all data)

export const GetAllPackingData = BaseIP +"packingDetails/getPackingDetailsList" // (to GET all packing data) (Todays Packing Details Table)
export const GetBundleData = BaseIP +"packingDetails/getAllPackingDetails" // (to GET all bundle table data) (Todays Packing Details Table)

    //=======Barcode Generate==========
export const GetBarcodeData = BaseIP +"reports/barcodePrintingReport/generateBarcode" // (to GET Barcode Data) (Todays Packing Details Table) (params => ?packingId=2505020002&barcodeSize=1)

    
//=========================Rack Release ===================================================
export const RackRelease = BaseIP +"packingDetails/rackRelease" // (params =?rackNumberId) (PUT)



/* =====formula===========
wtRange = (wt / pcs * 12) / len;

wtRange = (wt / pcs * 3660) / len;

wtRange = (wt / pcs * 144) / len;
=================================

quantity = wt * (len / 12) * pcs;

quantity = wt * (len / 3660) * pcs;

quantity = wt * (len / 144) * pcs;


*/

//============================== Rack Remark ========================================================
export const GetRackRemark = BaseIP +"production/rackRemark/getRackRemarkData"
export const SaveRackRemarkUpdates = BaseIP + "production/rackRemark/saveRackRemark"
